$(document).ready(function () {
    // Preserve the Turbo theme's delegated desktop cart trigger. The shared
    // header controller owns the mobile drawer trigger and state.
    $(document).on('click.desktopMiniCart', '.mini_cart', function(e){
        if (window.matchMedia('(max-width: 798px)').matches) return;
        e.preventDefault();
        if ($(this).next(".cart_content").length > 0) {
            $("body").toggleClass("openCart");
        }
    });
    $(".closeButton, .body-overlay").on('click', function(){
        $("body").removeClass("openCart");
    });
});
